var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bankeys-footer"},[_c('img',{staticClass:"esign-logo",attrs:{"src":require('@/assets/images/esign-logo.svg'),"alt":""}}),_c('span',{staticClass:"footer-text"},[_vm._v("由e签宝提供技术支持")])])}
var staticRenderFns = []

export { render, staticRenderFns }